import React, { ReactNode } from 'react';

import { Divider, Stack, Title } from '@mantine/core';

interface HeaderProps {
  title: string;
  subtitleComponent?: ReactNode;
}

export function Header({ title, subtitleComponent }: HeaderProps) {
  return (
    <>
      <Stack spacing={6} p={16}>
        <Title order={3}>{title}</Title>
        {subtitleComponent && subtitleComponent}
      </Stack>
      <Divider sx={(theme) => ({ color: theme.colors.gray[0], opacity: 0.5 })} />
    </>
  );
}
